 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTML01_FRONTISPIECE from '@/components/xhtml/01_Frontispiece'
 import XHTML02_TITLE_PAGE from '@/components/xhtml/02_Title_Page'
 import XHTML04_COPYRIGHT from '@/components/xhtml/04_Copyright'
 import XHTML05_DEDICATION from '@/components/xhtml/05_Dedication'
 import XHTML06_CONTENTS from '@/components/xhtml/06_Contents'
 import XHTML07_IMAGE from '@/components/xhtml/07_Image'
 import XHTML08_INTRODUCTION from '@/components/xhtml/08_INTRODUCTION'
 import XHTML09_1___THE_GULF_AND_FISHING from '@/components/xhtml/09_1___The_Gulf_and_Fishing'
 import XHTML10_FISH from '@/components/xhtml/10_FISH'
 import XHTML11_2___INSHORE_MIXED_BAG from '@/components/xhtml/11_2___Inshore_Mixed_Bag'
 import XHTML12_3___CROAKERS__SCIAENIDAE__AND_GR from '@/components/xhtml/12_3___Croakers__Sciaenidae__and_Gr'
 import XHTML13_4___JACKS__CARANGIDAE from '@/components/xhtml/13_4___Jacks__Carangidae'
 import XHTML14_5___GREAT_AND_SMALL_PELAGIC_FISH from '@/components/xhtml/14_5___Great_and_Small_Pelagic_Fish'
 import XHTML15_6___SNAPPERS__LUTJANIDAE from '@/components/xhtml/15_6___Snappers__Lutjanidae'
 import XHTML16_7___GROUPERS_AND_SEABASS__SERRAN from '@/components/xhtml/16_7___Groupers_and_Seabass__Serran'
 import XHTML17_8___OFFSHORE_REEF__RUBBLE__AND_R from '@/components/xhtml/17_8___Offshore_Reef__Rubble__and_R'
 import XHTML18_9___DEEPWATER_GROUNDFISH from '@/components/xhtml/18_9___Deepwater_Groundfish'
 import XHTML19_10___ASSORTED_BLUE_WATER_PELAGIC from '@/components/xhtml/19_10___Assorted_Blue_Water_Pelagic'
 import XHTML20_11___ON_THE_SUBJECT_OF_GULF_MARI from '@/components/xhtml/20_11___On_the_Subject_of_Gulf_Mari'
 import XHTML21_12___RAYS__SKATES__AND_SHARKS__E from '@/components/xhtml/21_12___Rays__Skates__and_Sharks__E'
 import XHTML22_INVERTEBRATES from '@/components/xhtml/22_INVERTEBRATES'
 import XHTML23_13___BIVALVES__GASTROPODS__CEPHA from '@/components/xhtml/23_13___Bivalves__Gastropods__Cepha'
 import XHTML24_14___SHRIMP__CRABS__AND_OTHER_CR from '@/components/xhtml/24_14___Shrimp__Crabs__and_Other_Cr'
 import XHTML25_15___A_FEW_WORDS_ABOUT_EDIBLE_PL from '@/components/xhtml/25_15___A_Few_Words_about_Edible_Pl'
 import XHTML26_16___SOME_HONORARY_FRESHWATER_IN from '@/components/xhtml/26_16___Some_Honorary_Freshwater_In'
 import XHTML27_NUTS_AND_BOLTS from '@/components/xhtml/27_NUTS_AND_BOLTS'
 import XHTML28_17___FINDING__BUYING__AND_PROCES from '@/components/xhtml/28_17___Finding__Buying__and_Proces'
 import XHTML29_18___THE_ABCS from '@/components/xhtml/29_18___The_ABCs'
 import XHTML30_19___BUYING_AND_STORING_SEAFOOD from '@/components/xhtml/30_19___Buying_and_Storing_Seafood'
 import XHTML31_20___CUTTING_FISH__SHUCKING_OYST from '@/components/xhtml/31_20___Cutting_Fish__Shucking_Oyst'
 import XHTML32_RECIPES from '@/components/xhtml/32_RECIPES'
 import XHTML33_21___WHOLE_FISH from '@/components/xhtml/33_21___Whole_Fish'
 import XHTML34_22___CUT_FISH from '@/components/xhtml/34_22___Cut_Fish'
 import XHTML35_23___CRUSTACEANS from '@/components/xhtml/35_23___Crustaceans'
 import XHTML36_24___BIVALVES__GASTROPODS__AND_C from '@/components/xhtml/36_24___Bivalves__Gastropods__and_C'
 import XHTML37_25___PRESERVING_THE_CATCH from '@/components/xhtml/37_25___Preserving_the_Catch'
 import XHTML38_26___BITS_AND_PIECES from '@/components/xhtml/38_26___Bits_and_Pieces'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
 import XHTML39_ACKNOWLEDGMENTS from '@/components/xhtml/39_ACKNOWLEDGMENTS'
 import XHTML40_APPENDIX_I__COMMON_SEAFOOD_HAZAR from '@/components/xhtml/40_APPENDIX_I__COMMON_SEAFOOD_HAZAR'
 import XHTML41_APPENDIX_II__SPECIES_NOT_DESCRIB from '@/components/xhtml/41_APPENDIX_II__SPECIES_NOT_DESCRIB'
 import XHTML42_FURTHER_READING from '@/components/xhtml/42_FURTHER_READING'
 import XHTML43_RECIPE_INDEX from '@/components/xhtml/43_RECIPE_INDEX'
 import XHTML44_GENERAL_INDEX from '@/components/xhtml/44_GENERAL_INDEX'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/06_Contents",
 			"name" : "xhtml/06_Contents",
 			"component" : XHTML06_CONTENTS
 		},
 		{
 			"path" : "/xhtml/07_Image",
 			"name" : "xhtml/07_Image",
 			"component" : XHTML07_IMAGE
 		},
 		{
 			"path" : "/xhtml/08_INTRODUCTION",
 			"name" : "xhtml/08_INTRODUCTION",
 			"component" : XHTML08_INTRODUCTION
 		},
 		{
 			"path" : "/xhtml/09_1___The_Gulf_and_Fishing",
 			"name" : "xhtml/09_1___The_Gulf_and_Fishing",
 			"component" : XHTML09_1___THE_GULF_AND_FISHING
 		},
 		{
 			"path" : "/xhtml/10_FISH",
 			"name" : "xhtml/10_FISH",
 			"component" : XHTML10_FISH
 		},
 		{
 			"path" : "/xhtml/11_2___Inshore_Mixed_Bag",
 			"name" : "xhtml/11_2___Inshore_Mixed_Bag",
 			"component" : XHTML11_2___INSHORE_MIXED_BAG
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js